// Maps a task to a single visual state for calendar/timeline views. Order
// matters: cancelled > completed (verified vs unverified) > in-progress >
// assigned > unassigned. Overdue is applied as an additional class on top.
export function taskState(t) {
  if (!t) return "unassigned";
  if (t.status === "cancelled") return "cancelled";
  if (t.status === "completed") return t.is_verified ? "verified" : "completed-unverified";
  if (t.status === "in_progress") return "in-progress";
  if (!t.employee_id) return "unassigned";
  return "assigned";
}

export const STATUS_LABELS = {
  unassigned: "Unassigned",
  assigned: "Assigned",
  "in-progress": "In progress",
  "completed-unverified": "Completed · pending verify",
  verified: "Verified",
  cancelled: "Cancelled",
  overdue: "Overdue",
};

export const LEGEND_ENTRIES = [
  { state: "unassigned", label: STATUS_LABELS.unassigned },
  { state: "assigned", label: STATUS_LABELS.assigned },
  { state: "in-progress", label: STATUS_LABELS["in-progress"] },
  { state: "completed-unverified", label: STATUS_LABELS["completed-unverified"] },
  { state: "verified", label: STATUS_LABELS.verified },
  { state: "overdue", label: STATUS_LABELS.overdue },
];

// State keys for the (non-excluded) legend entries — seeds the calendar's
// "all checked" status filter and defines which states are filterable.
export function legendStates(exclude = []) {
  return LEGEND_ENTRIES.filter((l) => !exclude.includes(l.state)).map((l) => l.state);
}

// Overdue overlay predicate: due before today and still actionable. `todayKey`
// is "YYYY-MM-DD". A task can be overdue on top of its base state.
export function isOverdue(t, todayKey) {
  const dueKey = (t?.due_date || "").slice(0, 10);
  return !!dueKey && dueKey < todayKey && t.status !== "completed" && t.status !== "cancelled";
}

// Tally tasks by their visual state. `overdue` is counted in addition to the
// task's base state since it's an overlay (a task can be e.g. in-progress AND
// overdue at the same time). `todayKey` is "YYYY-MM-DD".
export function countByState(tasks, todayKey) {
  const counts = {
    unassigned: 0,
    assigned: 0,
    "in-progress": 0,
    "completed-unverified": 0,
    verified: 0,
    cancelled: 0,
    overdue: 0,
  };
  if (!Array.isArray(tasks)) return counts;
  for (const t of tasks) {
    counts[taskState(t)]++;
    const dueKey = (t.due_date || "").slice(0, 10);
    if (dueKey && dueKey < todayKey && t.status !== "completed" && t.status !== "cancelled") {
      counts.overdue++;
    }
  }
  return counts;
}
